import React, { createContext, useContext, useState } from "react";

// Define the shape of the preview content
export interface PreviewContentType {
  url: string;
  name: string;
  fileType: string;
  size?: number;
  content?: string;
}

// Create the context with default values
interface PreviewContextType {
  previewContent: PreviewContentType | null;
  setPreviewContent: (content: PreviewContentType | null) => void;
  previewWidth: number;
  setPreviewWidth: (width: number) => void;
}

const PreviewContext = createContext<PreviewContextType>({
  previewContent: null,
  setPreviewContent: () => {},
  previewWidth: 50,
  setPreviewWidth: () => {},
});

// Hook to use the preview context
export const usePreview = () => useContext(PreviewContext);

// Provider component
export const PreviewProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [previewContent, setPreviewContent] = useState<PreviewContentType | null>(null);
  const [previewWidth, setPreviewWidth] = useState(50);

  return (
    <PreviewContext.Provider value={{ previewContent, setPreviewContent, previewWidth, setPreviewWidth }}>
      {children}
    </PreviewContext.Provider>
  );
};